import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {from, Observable} from 'rxjs';
import {Auth} from "@aws-amplify/auth";
import {CognitoUserSession} from "amazon-cognito-identity-js";
import {CONFIG} from "../../config";
import {switchMap} from "rxjs/operators";


const API_URL = CONFIG.api.invokeUrl

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private idToken: Promise<CognitoUserSession>;

  constructor() {
    this.idToken = Auth.currentSession();
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.match('^' + API_URL)) {
      return from(this.idToken)
        .pipe(
          switchMap((session) => {
            let token = session.getIdToken().getJwtToken();
            if (!token)
              return next.handle(request);
            const headers = request.headers
              .set('Authorization', 'Bearer ' + token)
              .append('Content-Type', 'application/json');
            const requestClone = request.clone({
              headers
            });
            return next.handle(requestClone);
          })
        );
    }
    else {
      return next.handle(request);
    }
  }
}
